var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGraduation48Filled = function SvgIconGraduation48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.36c-.4 0-.8-.08-1.18-.25L12.8 26.66v5.2c0 .67.39 1.28 1.01 1.55l9.01 4.03c.38.17.78.25 1.19.25.41 0 .81-.08 1.18-.25l9.01-4.03a1.7 1.7 0 0 0 1.01-1.55v-5.2l-10.02 4.45c-.37.17-.78.25-1.18.25H24Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 19.33c0-1.16-.66-2.18-1.72-2.65l-13.8-6.13c-.75-.33-1.6-.33-2.35 0l-13.8 6.13a2.868 2.868 0 0 0-1.72 2.65c0 1.16.66 2.18 1.72 2.65l13.8 6.13c.38.17.78.25 1.18.25.4 0 .8-.08 1.18-.25l12.12-5.39v8.6h3.4v-12l-.01.01Z",
    fill: "current"
  })));
};
export default SvgIconGraduation48Filled;